import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { NavigationExtras, Router } from "@angular/router";
import { IonInfiniteScroll, LoadingController, NavController } from '@ionic/angular';
import { AccountModel } from 'src/models/accounts/account';
import { ProfileModel } from 'src/models/profile/profile';
import { Branch, BranchModel } from 'src/models/system/branch-collection/branch';
import { CrudService } from '../../admin/services/crud/crud.service';
import { FireSQL } from 'firesql';
import * as firebase from 'firebase/app';
import 'firesql/rx';
import { map, switchMap, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { async } from '@angular/core/testing';
import { BranchTypeCompose, ProfileBranchModel } from 'src/models/system/branch-collection/profile-branch';
import { ClinicModel } from 'src/models/system/clinic/clinic';
import { ProfileUsersModel } from 'src/models/profile/profile-users/profile-users';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../expert-appointments-for-subscriber/core/loader.service';

@Component({
  selector: 'app-search-bar-doctor-array',
  templateUrl: './search-bar-doctor.component.html',
  styleUrls: ['./search-bar-doctor.component.scss'],
})
export class SearchBarDoctorArrayComponent implements OnInit {
  tnc: string = "tc";

  @Input() title: string;

  @ViewChild(IonInfiniteScroll, { static: true }) infiniteScroll: IonInfiniteScroll;
  itemListData = [];

  isItemAvailable = false;
  items = [];
  limit: number = 10;

  branches = [] as {branch: BranchModel, ref: string}[];
  profiles = [] as {account: AccountModel, accountRef: string, profile: ProfileModel, profileRef: firebase.firestore.DocumentReference}[];
  constructor(private route: Router,
    private profileService: CrudService<object, ProfileModel>,
    private accountService: CrudService<object, AccountModel>,
    private branchService: CrudService<object, BranchTypeCompose>,
    private profileBranchservice: CrudService<object, ProfileBranchModel>,
    private firestore: AngularFirestore,
    private navCtrl: NavController,
    private loadingController: LoadingController,
    public translate: TranslateService,
    private ionLoader: LoaderService,
  ) { }

  ngOnInit() {
    this.loadData(false, "");

  }

  showLoader() {
    this.ionLoader.presentLoading();
  }

  hideLoader() {
    this.ionLoader.dismiss();
  }


  initializeItems() {
    this.items = ["Ram", "gopi", "dravid"];
  }

  arrayUnique(array: { obj: AccountModel, title: string, branchTitle: string, profileId: firebase.firestore.DocumentReference }[]) {
    var a = array.concat();
    console.log(a);

    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i].obj.name === a[j].obj.name &&
          a[i].obj.surname === a[j].obj.surname &&
          a[i].obj.gender === a[j].obj.gender &&
          a[i].obj.height === a[j].obj.height &&
          a[i].obj.weight === a[j].obj.weight &&
          a[i].obj.bloodGroup === a[j].obj.bloodGroup)
          a.splice(j--, 1);
      }
    }

    return a;
  }




  arrayUniqueBranch(array: BranchModel[]) {
    var a = array.concat();
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i].title === a[j].title)
          a.splice(j--, 1);
      }
    }

    return a;
  }





  async getItems(ev: any) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    let val: string = ev.target.value;


    // if the value is an empty string don't filter the items
    if (val && val.trim() !== '' && val.length >= 3) {
      this.showLoader();
      let serachKey = val.toUpperCase();
      this.profiles = [];
      await this.getAccounts(serachKey).then(res => {
        if(res !== null) {
          this.profiles = res;
        } else {
          this.profiles = [];
        }
        console.log(this.profiles);
        console.log(this.profiles.length);
        
        
      }).finally( () => {
        this.isItemAvailable = true;
        this.getBranches(serachKey).then(resBranch => {
          this.branches = resBranch;
        }).finally(() => {
          this.hideLoader();
        }).catch(err => {
          console.log(err);
        });
      }).catch(err => {
        console.log(err);    
      });

    } else {
      this.isItemAvailable = false;
    }

  }

  getBranches(searchKey: string): Promise<{branch: BranchModel, ref: string}[]> {
    return new Promise<{branch: BranchModel, ref: string}[]>((resolve, reject) => {
      return this.firestore.collectionGroup('branches').get().toPromise().then(res => {
        if(res && res.docs && res.docs.length > 0) {
          let data = [] as {branch: BranchModel, ref: string}[];
          res.docs.forEach((item) => {
            let branch = item.data() as BranchModel;
            branch.title = branch.title.toUpperCase();
            if(branch.title.includes(searchKey))
            data.push({branch: branch, ref: item.ref.path});
          });
          resolve(data);
        }
      }).catch(err => {
        console.log(err);
      });
    });
  }


  async getAccounts(serachKey: string):Promise<{account: AccountModel, accountRef: string, profile: ProfileModel, profileRef: firebase.firestore.DocumentReference}[]> {
    let allProfiles = [];
    return new Promise<{account: AccountModel, accountRef: string, profile: ProfileModel, profileRef: firebase.firestore.DocumentReference}[]>((resolve, reject) => {
     return this.firestore.collection('accounts', ref => ref.where('isExpert', '==', true).where('confirmStatusByAdmin','==', true)).get()
      .toPromise().then(res => {
        if(res && res.docs && res.docs.length > 0) {
          res.docs.forEach(async (item) => {
            let account = item.data() as AccountModel;
            await this.getProfiles(account, item.id, serachKey).then(result => {
              if(result !== null)
              allProfiles.push(result);
            }).finally(() => {
              resolve(allProfiles);

            });
          });
        } else {
          resolve(null);
        }
      }).catch(err => {
        console.log(err); 
      });
    });
  }

  async getProfiles(account: AccountModel, id: string, serachKey: string):Promise<{account: AccountModel, accountRef: string, profile: ProfileModel, profileRef: firebase.firestore.DocumentReference}> {
    return new Promise<{account: AccountModel, accountRef: string, profile: ProfileModel, profileRef: firebase.firestore.DocumentReference}>((resolve, reject) => {
      return this.firestore.collection('accounts').doc(id).collection('profile', ref => ref.limit(1)).get().toPromise()
      .then(resProfile => {
        if(resProfile && resProfile.docs && resProfile.docs.length > 0) {
          let profile = resProfile.docs[0].data() as ProfileModel;
          let profileId = resProfile.docs[0].id;
          account.name = account.name.toUpperCase();
          if(account.name.includes(serachKey)){
            resolve({account: account, accountRef: id, profile: profile, profileRef: this.firestore.collection('accounts').doc(id).collection('profile').doc(profileId).ref});
          }
          
        } else {
          resolve(null);
        }
      }).catch(err => {
        console.log(err); 
      });
    });
  }


  expertDetailSearch() {
    this.route.navigate(['expert-search-in-detail']);
  }


  doctorProfile(profileRef: firebase.firestore.DocumentReference) {
    let navigationExtras: NavigationExtras = {
      state: {
        profilePath: profileRef.path,
        profileId: profileRef.id
      }
    };
    this.navCtrl.navigateForward(['doctorprofile'], navigationExtras);

  }

  clinicDetail(clinicRef: string) {
    let navigationExtras: NavigationExtras = {
      state: {
        clinicId: clinicRef
      }
    };
    this.navCtrl.navigateForward(['clinic-detail'], navigationExtras);
  }

  branchesPage(branchRef: string) {
    let navigationExtras: NavigationExtras = {
      state: {
        branchId: branchRef
      }
    };
    this.navCtrl.navigateForward(['branch-detail'], navigationExtras);
  }

  loadData(isFirstLoad, event) {

    this.itemListData = [];
    this.profiles.forEach((item) => {
      this.itemListData.push(item);
    });
    console.log(this.itemListData);


    if (isFirstLoad)
      event.target.complete();
  }
  doInfinite(event) {
    this.loadData(true, event);
  }




}
